import React from 'react';
import { RoutePermittedRole } from 'shared/constants/AppConst';
const CreateNodelForm = React.lazy(() => import('./CreateForm'));
const NodalTable = React.lazy(()=>import('./listing'));
const EditForm = React.lazy(()=>import('./EditForm'));


export const NodalPointConfigs = [
    {
      permittedRole: RoutePermittedRole.corporateAdmin,
      path: '/onboard-tenant/nodel-point/create',
      element: <CreateNodelForm />,
    },
  
    {
      permittedRole: RoutePermittedRole.ALL,
      path: '/onboard-tenant/nodal-point/table',
      element: <NodalTable />,
    },
  
    {
      permittedRole: RoutePermittedRole.corporateAdmin,
      path: '/onboard-tenant/nodel-point/edit/:id',
      element: <EditForm />,
    },
  ];
  